import { isDeepEqual } from '@attain-apps/data-utils'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Loads the calculated functionalizations whenever the set of labs assigned to
 * this Lab Service changes — after navigating to another record (the list
 * reloads) or when labs are added/removed.
 */
export const loadForCurrentEntityOnListChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.plugins.currentListPlugin.feature.selectors.entities.asObservable.pipe(
      rxjs.distinctUntilChanged(isDeepEqual),
      rxjs.map(() =>
        feature.actions.loadForCurrentEntity.request
          .from('loadForCurrentEntityOnListChange (effect)')
          .create(),
      ),
    ),
)
